declare global {
  interface Window {
    bodyScrollLock?: {
      disableBodyScroll: (targetElement: Element) => void
      clearAllBodyScrollLocks: () => void
    }
  }
}

const modalOpenTimeouts = new Map<string, number>()
const modalCloseTimeouts = new Map<string, number>()

const openModal = (id: string, context?: unknown) => {
  // Ensure the DOM is synchronized before accessing the element
  requestAnimationFrame(() => {
    const modal = document.getElementById(id)
    const bodyScrollTarget = modal && modal.querySelector('.modal-body')

    if (!modal) {
      return
    }

    let modalContext = ''
    try {
      modalContext = JSON.stringify(context)
    } catch (err) {
      console.warn('Could not stringify context', context)
    }

    const closeTimeoutId = modalCloseTimeouts.get(id)
    if (closeTimeoutId !== undefined) {
      window.clearTimeout(closeTimeoutId)
      modalCloseTimeouts.delete(id)
    }

    const openTimeoutId = modalOpenTimeouts.get(id)
    if (openTimeoutId !== undefined) {
      window.clearTimeout(openTimeoutId)
    }

    // Modal was hide for performance reasons
    modal.style.display = 'block'
    // Need to enable animation
    const nextOpenTimeoutId = window.setTimeout(() => {
      if (modalOpenTimeouts.get(id) !== nextOpenTimeoutId) {
        return
      }

      modalOpenTimeouts.delete(id)
      document.dispatchEvent(new Event(`open-${id}`))
      modal.classList.add('open')
      modal.setAttribute('aria-hidden', 'false')
      modal.setAttribute('aria-expanded', 'true')
      modal.setAttribute('tabindex', '0')
      if (modalContext) {
        modal.setAttribute('data-context', modalContext)
      } else {
        modal.removeAttribute('data-context')
      }
      modal.focus()
      if (bodyScrollTarget) window.bodyScrollLock?.disableBodyScroll(bodyScrollTarget)
    })
    modalOpenTimeouts.set(id, nextOpenTimeoutId)
  })
}

const closeModal = (id: string) => {
  const modal = document.getElementById(id)
  const allModalOpened = document.querySelectorAll('.modal.open')

  if (!modal) {
    return
  }

  const openTimeoutId = modalOpenTimeouts.get(id)
  if (openTimeoutId !== undefined) {
    window.clearTimeout(openTimeoutId)
    modalOpenTimeouts.delete(id)
  }

  const closeTimeoutId = modalCloseTimeouts.get(id)
  if (closeTimeoutId !== undefined) {
    window.clearTimeout(closeTimeoutId)
    modalCloseTimeouts.delete(id)
  }

  modal.classList.remove('open')
  modal.setAttribute('aria-hidden', 'true')
  modal.setAttribute('aria-expanded', 'false')
  modal.setAttribute('tabindex', '-1')
  if (allModalOpened.length == 1) {
    window.bodyScrollLock?.clearAllBodyScrollLocks()
  }
  const nextCloseTimeoutId = window.setTimeout(() => {
    if (modalCloseTimeouts.get(id) !== nextCloseTimeoutId) {
      return
    }

    modalCloseTimeouts.delete(id)
    if (modal.classList.contains('open')) {
      return
    }

    modal.style.display = 'none'
  }, 1000)
  modalCloseTimeouts.set(id, nextCloseTimeoutId)
}

export { openModal, closeModal }
